import AuthLogin from "../../pages/AuthLogin";
import Loader from "../../usercontrols/loader/loader";
import { Route, Routes } from "react-router-dom";
import { Suspense } from "react";
import LayoutContainer from "../LayoutContainer";
import AccessDeniedError from "../../pages/AccessDeniedError";

interface Props {
  isAuthenticated: boolean;
  isUserLoggedIn: boolean;
  userHasPortalAccess: boolean;
}

const RootRouter = (props: Props) => {
  return (
    <>
      <Suspense fallback={<div className="container">Loading...</div>}>
        {!props.isAuthenticated ? (
          <Routes>
            <Route>{<Route path="*" element={<AuthLogin />} />}</Route>
          </Routes>
        ) : props.isUserLoggedIn ? (
          props.userHasPortalAccess ? (
            <LayoutContainer />
          ) : (
            <AccessDeniedError />
          )
        ) : (
          <Loader />
        )}
      </Suspense>
    </>
  );
};

export default RootRouter;
